import { render, staticRenderFns } from "./Box8.vue?vue&type=template&id=84734944&scoped=true&"
import script from "./Box8.vue?vue&type=script&lang=js&"
export * from "./Box8.vue?vue&type=script&lang=js&"
import style0 from "./Box8.vue?vue&type=style&index=0&id=84734944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84734944",
  null
  
)

export default component.exports